
import Vue from 'vue';
import Banner from '../components-pc/Banner.vue';
import HomeFooter from '../components-pc/HomeFooter.vue';

export default Vue.extend({
  name: 'RulePc',
  components: {
    Banner,
    HomeFooter,
  },
});
